
export default function Products() {
  const products = [
    {
      name: 'VPN',
      label: 'SECURITY',
      description: 'Protect your online privacy with our advanced VPN solution. Secure encryption, fast connection speeds, and unlimited bandwidth ensure your data stays private across all networks.',
      gradient: 'linear-gradient(135deg, #667eea 0%, #06b6d4 100%)',
      image: 'https://public.readdy.ai/ai/img_res/60cce03d7a78b9599aeeb7d1f14cbd8b.jpg'
    },
    {
      name: 'Cleaner',
      label: 'OPTIMIZATION',
      description: 'Optimize your device performance with intelligent cleaning tools. Remove junk files, manage storage efficiently, and keep your iOS device running smoothly with one-tap optimization.',
      gradient: 'linear-gradient(135deg, #10b981 0%, #84cc16 100%)',
      image: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20broom%20and%20sparkle%20icon%20illustration%20with%20green%20gradient%20glow%2C%20abstract%20geometric%20shapes%2C%20fresh%20white%20and%20light%20green%20color%20palette%2C%20floating%20in%20soft%20gradient%20background%2C%20modern%20digital%20art%20style%2C%20simple%20composition%20representing%20device%20optimization%20and%20cleaning&width=600&height=400&seq=cleaner-product-001&orientation=landscape'
    }
  ];

  return (
    <section id="products" className="py-24 bg-gray-50" data-product-shop>
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">Our Products</h2>
          <p className="text-lg text-gray-600">
            Designed to enhance your mobile experience
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          {products.map((product, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div
                className="h-64 flex items-center justify-center relative overflow-hidden"
                style={{ background: product.gradient }}
              >
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover opacity-80"
                />
              </div>
              <div className="p-8">
                <span className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wide bg-blue-50 text-blue-600 mb-4">
                  {product.label}
                </span>
                <h3 className="text-3xl font-bold text-gray-900 mb-4">
                  {product.name}
                </h3>
                <p className="text-base text-gray-600 leading-relaxed">
                  {product.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
